import React, { Component } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import Select from "react-select";
import { Alert, Card, CardBody, CardHeader, Col, Label, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { layout, messages, roles } from "../../../../common/constants";
import { formatHelper } from "../../../../common/helpers";
import { DataTable, ExportCSV } from "../../../../components";
import { getOfferDetailsBalance } from "../../../../store/report/actions";
import { selectOfferDetailsBalanceColumms } from "../../../../store/report/selector";
import { getStores } from "../../../../store/store/actions";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { selectUserRole } from "../../../../store/user/selector";
import * as columns from "./_columns";
import { getOfferDetailsBalance as getOfferDetailsBalanceService } from "../../../../service/report";
import { exportExcel } from "./excel";
class OfferBalance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      pageDetails: 1,
      pageNames: 1,
      selectedStore: null,
      loadingExport: false,
    };

    this.handleObtainDetailedReportExport =
      this.handleObtainDetailedReportExport.bind(this);
    this.handlePageDetailsChange = this.handlePageDetailsChange.bind(this);
    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      this.props.getOfferDetailsBalance({
        page: this.state.pageDetails,
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetOfferBalance();
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  handleOfferBalanceDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });

    if (startDate != null && endDate != null) {
      this.props.getOfferDetailsBalance({
        page: this.state.pageDetails,
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  performGetOfferBalance(reset = false, getOfferBalance, page) {
    const store = this.state.selectedStore.value;
    getOfferBalance({
      page,
      startDate: this.state.startDate._d,
      endDate: this.state.endDate._d,
      store,
      reset,
    });
  }

  async handlePageDetailsChange(pageDetails) {
    await this.setState({ pageDetails: pageDetails });
    this.performGetOfferBalance(
      false,
      this.props.getOfferDetailsBalance,
      this.state.pageDetails
    );
  }

  handleObtainDetailedReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    getOfferDetailsBalanceService(
      0,
      startDate._d,
      endDate._d,
      selectedStore.value
    )
      .then((response) => {
        exportExcel(
          selectOfferDetailsBalanceColumms(undefined, response.data.data),
          selectedStore,
          startDate,
          endDate
        );
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  renderDataTable(
    columns,
    data,
    page,
    total,
    pageSize,
    loading,
    handlePageChange
  ) {
    return (
      <DataTable
        data={data}
        keyField="id"
        columns={columns}
        page={page}
        totalSize={total}
        sizePerPage={pageSize}
        loading={loading}
        onPageChange={handlePageChange}
      />
    );
  }

  render() {
    const { startDate, endDate, pageDetails, loadingExport } = this.state;
    const {
      offerDetailsBalance,
      totalDetails,
      pageSizeDetails,
      loadingDetails,
    } = this.props;

    return (
      <div>
        <Card>
          <CardHeader>
            <i className="icon-chart" />
            Balance por Ofertas
          </CardHeader>
          <CardBody>
            {(this.props.role == roles.SUPER_ADMIN ||
              this.props.role == roles.ADMIN) && (
              <Row className="my-4">
                <Col sm="1">
                  <Label className="mt-2">Tienda:</Label>
                </Col>

                <Col sm="4">
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isLoading={this.props.loadingStores}
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return messages.SELECT_NO_OPTIONS;
                    }}
                    placeholder=""
                    options={this.props.stores}
                    loadingMessage={() => {
                      return messages.SELECT_LOADING;
                    }}
                    onChange={this.handleStoreChange}
                    value={this.state.selectedStore}
                    isDisabled={this.props.loadingStores || loadingDetails}
                  />
                </Col>
              </Row>
            )}

            <Row className="mb-2">
              <Col md="5">
                <DateRangePicker
                  startDate={startDate}
                  startDateId="startDate"
                  endDate={endDate}
                  endDateId="endDate"
                  displayFormat={"DD/MM/YYYY"}
                  disabled={this.props.loadingStores || loadingDetails}
                  onDatesChange={({ startDate, endDate }) =>
                    this.handleOfferBalanceDateChange(startDate, endDate)
                  }
                  focusedInput={this.state.focusedInput}
                  onFocusChange={(focusedInput) =>
                    this.setState({ focusedInput })
                  }
                  startDatePlaceholderText="Fecha Inicio"
                  endDatePlaceholderText="Fecha Fin"
                  small
                  isOutsideRange={() => false}
                  hideKeyboardShortcutsPanel
                  minimumNights={0}
                />
              </Col>
              <Col md="7">
                {this.state.startDate && this.state.endDate ? (
                  <Row>
                    <Col md="12">
                      <ExportCSV
                        disabled={loadingExport}
                        exportCSV={this.handleObtainDetailedReportExport}
                        minWidth={800}
                        detailed={true}
                      />
                    </Col>
                  </Row>
                ) : null}
              </Col>
            </Row>
            <hr className="my-4" />
            {startDate != null && endDate != null ? (
              <Row>
                <Col>
                  <Row className="mb-2">
                    <Col>
                      <b>Total de Ventas (S/):</b>{" "}
                      {formatHelper.toMoney(this.props.totalBought)}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsOfferDetailsXS,
                          offerDetailsBalance,
                          pageDetails,
                          totalDetails,
                          pageSizeDetails,
                          loadingDetails,
                          this.handlePageDetailsChange
                        )}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(
                          columns.columnsOfferDetailsSM,
                          offerDetailsBalance,
                          pageDetails,
                          totalDetails,
                          pageSizeDetails,
                          loadingDetails,
                          this.handlePageDetailsChange
                        )}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsOfferDetailsMD,
                          offerDetailsBalance,
                          pageDetails,
                          totalDetails,
                          pageSizeDetails,
                          loadingDetails,
                          this.handlePageDetailsChange
                        )}
                      </MediaQuery>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">
                    Seleccione un rango de fechas para visualizar los datos
                  </Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const offerDetailsBalanceList = state.report.offerDetailsBalanceList;
  return {
    offerDetailsBalance: selectOfferDetailsBalanceColumms(state),
    totalBought: offerDetailsBalanceList.totalBought,
    totalDetails: offerDetailsBalanceList.total,
    pageSizeDetails: offerDetailsBalanceList.pageSize,
    errorDetails: offerDetailsBalanceList.error,
    loadingDetails: offerDetailsBalanceList.loading,

    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getOfferDetailsBalance,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferBalance);



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/OfferBalance/OfferBalance.js